import { PolicyDto } from './dto-insurance';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { AgentDto, DependantDto, DynamicFormDto, DynamicPayloadDto, MemberDto, MemberSearchDto, ResultListDto } from "./dto";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class HttpDependantService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/dependant', authService);
	}
	public getForm(): Observable<DynamicFormDto> {
		return super.doGet(true, "/form");
	}
	public get(id: number): Observable<DynamicFormDto> {
		return super.doGet(true, `/${id}`);
	}
	public edit(id: number, payload: DynamicPayloadDto): Observable<DynamicFormDto> {
		return super.doPost(true, `/${id}`, payload);
	}
	public getEntity(id: number): Observable<DependantDto> {
		return super.doGet(true, `/${id}/entity`);
	}
	public createForPolicy(policy: PolicyDto, payload: DynamicPayloadDto): Observable<DynamicFormDto> {
		return super.doPost(true, `/?policyId=${policy.id}`, payload);
	}
}
